import PropTypes from "prop-types";
import { CheckCircle2, Loader2, Sparkles } from "lucide-react";
import { relativeTime } from "@/lib/format";

export function MessageBubbleFooter({
  isInbound,
  isDraft,
  isSending,
  isFailed,
  isDelivered,
  isSent,
  assistantName,
  status,
  displayTime,
}) {
  return (
    <>
      {isDraft && (
        <span className="inline-flex items-center gap-1 font-semibold">
          <Sparkles size={9} /> {assistantName} draft
        </span>
      )}
      {isSending && (
        <span className="inline-flex items-center gap-1">
          <Loader2 size={9} className="animate-spin" /> Sending…
        </span>
      )}
      {isDelivered && (
        <span className="inline-flex items-center gap-1">
          <CheckCircle2 size={9} /> Delivered
        </span>
      )}
      {isSent && !isDelivered && (
        <span className="inline-flex items-center gap-1">
          <CheckCircle2 size={9} /> Sent
        </span>
      )}
      {isFailed && <span className="inline-flex items-center gap-1 font-semibold">Failed</span>}
      {!isDraft && !isDelivered && !isSending && !isFailed && !isSent && !isInbound && (
        <span>{status}</span>
      )}
      <span className="ml-auto">{displayTime ? relativeTime(displayTime) : ""}</span>
    </>
  );
}

MessageBubbleFooter.propTypes = {
  isInbound: PropTypes.bool,
  isDraft: PropTypes.bool,
  isSending: PropTypes.bool,
  isFailed: PropTypes.bool,
  isDelivered: PropTypes.bool,
  isSent: PropTypes.bool,
  assistantName: PropTypes.string,
  status: PropTypes.string,
  displayTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
};
